<p-floatLabel [formGroup]="formGroup">
  <p-password [toggleMask]="true" formControlName="password" [minlength]="8" inputStyleClass="w-full" styleClass="w-full">
    <ng-template pTemplate="header">
      <h6>Pick a password</h6>
    </ng-template>
    <ng-template pTemplate="footer">
      <p-divider />
      <p class="mt-2">Requirements</p>
      <span
        [ngClass]="{
          'text-green-500 transition-all':
            !(password().value === undefined || password().value === null || password().value === '') &&
            !(typesErrors() && typesErrors()?.length) &&
            !isPasswordInvalidDueToMinLength() &&
            !this.password().errors?.['required'],
        }"
        >Minimum 8 characters</span
      >
      <p class="mt-2">Password must contain at least three of the following types of characters:</p>
      <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
        <li
          [ngClass]="{
            'text-green-500 transition-all':
              !(password().value === undefined || password().value === null || password().value === '') &&
              !(typesErrors() && typesErrors()?.lowercase) &&
              !isPasswordInvalidDueToLowercase() &&
              !this.password().errors?.['required'],
          }"
        >
          At least one lowercase
        </li>
        <li
          [ngClass]="{
            'text-green-500 transition-all':
              !(password().value === undefined || password().value === null || password().value === '') &&
              !(typesErrors() && typesErrors()?.uppercase) &&
              !isPasswordInvalidDueToUppercase() &&
              !this.password().errors?.['required'],
          }"
        >
          At least one uppercase
        </li>
        <li
          [ngClass]="{
            'text-green-500 transition-all':
              !(password().value === undefined || password().value === null || password().value === '') &&
              !(typesErrors() && typesErrors()?.numeric) &&
              !isPasswordInvalidDueToNumeric() &&
              !this.password().errors?.['required'],
          }"
        >
          At least one numeric
        </li>
        <li
          [ngClass]="{
            'text-green-500 transition-all':
              !(password().value === undefined || password().value === null || password().value === '') &&
              !(typesErrors() && typesErrors()?.specialChar) &&
              !isPasswordInvalidDueToSpecialChar() &&
              !this.password().errors?.['required'],
          }"
        >
          At least one special character
        </li>
      </ul>
    </ng-template>
  </p-password>
  <label [class]="labelStyleClass()"
    >{{ label() }}
    @if (isRequired()) {
      <span class="text-red-600">*</span>
    }
  </label>
</p-floatLabel>
